import {
  ATTEMPT_STATUSES,
  ISSUE_STATUSES,
  SCHEDULE_STATUSES,
} from "@miplatform/constants";
import {
  getDateWithAddedTime,
  getDurationInHours,
  isEmpty,
  toHour,
  toSnappedTime,
} from "@miplatform/utils";

const issueCompletedStatuses = [
  ISSUE_STATUSES.CLOSED,
  ISSUE_STATUSES.CANCELLED,
];

export const filterIssuesWithHistoryOnAttempt = (attempt = {}) => {
  return (attempt.issues || [])
    .filter(
      (x) =>
        (!x.issueResult &&
          attempt.attemptStatus !== ATTEMPT_STATUSES.CLOSED &&
          !issueCompletedStatuses.includes(x.status)) ||
        (x.issueResult && attempt.attemptStatus === ATTEMPT_STATUSES.CLOSED) ||
        (x.issueResult &&
          attempt.attemptStatus !== ATTEMPT_STATUSES.CLOSED &&
          x.issueResult.attemptId === attempt.id)
    )
    .map((x) => ({
      ...x,
      status: x.issueResult
        ? x.issueResult?.status ?? ISSUE_STATUSES.REPORTED
        : ISSUE_STATUSES.REPORTED,
    }));
};

export const getTimeSlot = (e) => {
  const startHour = toHour(
    getDateWithAddedTime(
      toSnappedTime(
        e.readOnly ? e.displayStartTime : e.scheduledStartDate,
        "floor"
      ),
      { h: e.delayedTime }
    )
  );

  const endHour = toHour(
    getDateWithAddedTime(
      toSnappedTime(
        e.readOnly ? e.displayEndTime : e.scheduledEndDate,
        "floor"
      ),
      { h: e.extendedTime + e.delayedTime }
    )
  );

  return [startHour, Math.max(startHour, endHour)];
};

// ---------------- attachEventTime helpers ----------------
export const attachEventTime = (e) => ({
  ...e,
  dataProcessedTime: new Date(),
  unfilteredIssues: e.issues,
  issues: filterIssuesWithHistoryOnAttempt(e).map((x) => ({
    ...x,
    status:
      !x.issueResult && x.status === ISSUE_STATUSES.CONFIRMED
        ? ISSUE_STATUSES.REPORTED
        : x.status,
  })),
  displayStartTime: e.startDate || e.scheduledStartDate,
  displayEndTime:
    e.endDate ||
    (e.attemptStatus === ATTEMPT_STATUSES.STARTED &&
      getDateWithAddedTime(e.startDate, {
        h: getDurationInHours(e.scheduledStartDate, e.scheduledEndDate),
      })) ||
    e.scheduledEndDate ||
    getDateWithAddedTime(e.scheduledStartDate, { m: e.expectedDuration }),
  noDrag: [
    ATTEMPT_STATUSES.STARTED,
    ATTEMPT_STATUSES.SUBMITTED,
    ATTEMPT_STATUSES.DISPATCHED,
    ATTEMPT_STATUSES.CLOSEOUT_IN_PROGRESS,
    ATTEMPT_STATUSES.CLOSED,
  ].includes(e.attemptStatus),
  readOnly: [
    ATTEMPT_STATUSES.STARTED,
    ATTEMPT_STATUSES.SUBMITTED,
    ATTEMPT_STATUSES.CLOSEOUT_IN_PROGRESS,
    ATTEMPT_STATUSES.CLOSED,
  ].includes(e.attemptStatus),
  isProposed: e.scheduleStatus === SCHEDULE_STATUSES.PROPOSED,
  hasProposed: !isEmpty(e.proposedRescheduleId),
});

export const attachEventTimes = (events) => events.map(attachEventTime);
